const muiFormControlLabel = (theme) => {
  theme.overrides.MuiFormControlLabel = {
    label: {
      fontSize: '12px',
    },
  };
};

export default muiFormControlLabel;
